const BOOK_URL = "https://consumer.scheduling.athena.io/?locationId=35522-1";
const API_BASE = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = "aph_visitor_id";

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch (err) {
    return "";
  }
}

function gtagEvent(name, parameters = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", name, parameters);
  }
}

function trackRemote(payload) {
  try {
    fetch(`${API_BASE}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (err) {
    /* analytics must never break the page */
  }
}

export function pushToDataLayer(event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

let lastTrackedPath = null;

export function pushVirtualPageView(location) {
  const path = `${location.pathname}${location.search}${location.hash}`;
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  pushToDataLayer({
    event: "virtual_page_view",
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
  gtagEvent("page_view", {
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function registerConversionClickTracking() {
  const handler = (e) => {
    const anchor = e.target.closest("a");
    if (!anchor) return;
    const href = anchor.getAttribute("href") || "";
    const testid = anchor.getAttribute("data-testid") || "";
    if (href.startsWith(BOOK_URL)) {
      const params = { link_testid: testid, page_path: window.location.pathname };
      pushToDataLayer({ event: "book_online_click", ...params });
      gtagEvent("book_online_click", params);
      trackRemote({ event: "book_online_click", ...params, visitor_id: getVisitorId() });
    } else if (href.startsWith("tel:")) {
      const params = { link_testid: testid, page_path: window.location.pathname };
      pushToDataLayer({ event: "call_click", ...params });
      gtagEvent("call_click", params);
      trackRemote({ event: "call_click", ...params, visitor_id: getVisitorId() });
    }
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}
